import React from "react";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {ControlPanelService} from "../../service/controlPanel/ControlPanelService";
import GuaranteeInAccount from "./GuaranteeInAccountView";
import {
    amount,
    amountCalculate,
    capacityMultipliedOneHundred,
    numberWithCommaEmptyValue,
    price,
    rateMultipliedByOneHundred
} from "../../utils/formatters/Numbers";
import NumberFormat from "react-number-format";
import {getSuggestedInAccount, withoutComma} from "../../utils/calculate/Amount";


export default class GuaranteeInAccountContainer extends React.Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();
        this.getGuaranteeInAccount = this.getGuaranteeInAccount.bind(this);
        this.disableStyleInstrument = this.disableStyleInstrument.bind(this);
        this.disableStyleInstrumentTemplate = this.disableStyleInstrumentTemplate.bind(this);
        this.disableStyleInstrumentAmountTemplate = this.disableStyleInstrumentAmountTemplate.bind(this);
        this.disableStyleInstrumentPriceTemplate = this.disableStyleInstrumentPriceTemplate.bind(this);
        this.disableStyleInstrumentNumberTemplate = this.disableStyleInstrumentNumberTemplate.bind(this);
        this.disableStyleInstrumentRateTemplate = this.disableStyleInstrumentRateTemplate.bind(this);
        this.disableStyleInstrumentCapacityTemplate = this.disableStyleInstrumentCapacityTemplate.bind(this);


        this.setAccount = this.setAccount.bind(this);
        this.calculateTotals = this.calculateTotals.bind(this);
        this.numberEditor = this.numberEditor.bind(this);
        this.onEditorValueChange = this.onEditorValueChange.bind(this);
        this.updateInLoanTotals = this.updateInLoanTotals.bind(this);
        this.setLoanAmount = this.setLoanAmount.bind(this);
        this.show = this.show.bind(this);
        this.setTotalsColor = this.setTotalsColor.bind(this);

        this.state = {
            loanId: props.loanId,
            maturity: props.maturity,
            loanAmount: props.loanAmount,
            account: props.account,
            guaranteeList: [],
            guaranteeAmountTotal: 0,
            marketAmountTotal: 0,
            guaranteeAmountInLoanTotal: 0,
            marketAmountInLoanTotal: 0,
            cssStyle:
                props.isHidden === undefined || !props.isHidden ? 'p-toggleable-content-enter-done'
                    : 'p-toggleable-content-collapsed',
            totalColor: 'green',
            isPrecioVal: props.isPrecioVal ? props.isPrecioVal : false,
        };
    }

    show() {
        this.setState({
            cssStyle: 'p-toggleable-content-enter-done',
        })
    }

    setMaturity(maturity) {
        this.setState({
            maturity: maturity,
        })
    }

    setLoanAmount(loanAmount) {
        this.setState({
            loanAmount: loanAmount,
        })
    }

    setAccount(account) {
        this.setState({
            guaranteeList: this.getGuaranteeInAccount(account)
        });
    }

    calculateSuggested(guaranteeAmountTotal) {
        let realGuaranteeAmountTotal = guaranteeAmountTotal !== undefined ? guaranteeAmountTotal : this.state.guaranteeAmountTotal;

        let guaranteeList = this.state.guaranteeList;

        guaranteeList.map((item) => {
            let prize = this.state.isPrecioVal ? item.precioValDescontado : item.precioDescontado;

            item.suggested = getSuggestedInAccount(this.state.loanAmount, realGuaranteeAmountTotal, prize);
            if (item.suggested < 0) {
                item.suggested = 0;
            }
            return '';
        });

        this.setState({
            guaranteeList: guaranteeList,
        });
    }

    getZeroNumberNewTitles(newTitles) {
        if (newTitles === undefined || newTitles === '') {
            return 0;
        } else {
            return newTitles;
        }
    }

    calculateAmount(row) {
        let prizeDiscount = this.state.isPrecioVal ? row.precioValDescontado : row.precioDescontado;
        let prize = this.state.isPrecioVal ? row.precioVal : row.precioMercado;

        row.guaranteeAmount = (this.getZeroNumberNewTitles(row.newTitles)) * prizeDiscount;
        row.marketAmount = (this.getZeroNumberNewTitles(row.newTitles)) * prize;

        return row;
    }

    updateInLoanTotals(guaranteeAmountInLoanTotal, marketAmountInLoanTotal) {
        this.setTotalsColor(this.state.guaranteeAmountTotal);
        this.setState({
            guaranteeAmountInLoanTotal: guaranteeAmountInLoanTotal,
            marketAmountInLoanTotal: marketAmountInLoanTotal,
        });

        this.calculateTotals(this.state.guaranteeList, guaranteeAmountInLoanTotal, marketAmountInLoanTotal);
        this.calculateSuggested(guaranteeAmountInLoanTotal);
    }


    calculateTotals(response, guaranteeAmountInLoanTotal, marketAmountInLoanTotal) {
        let guaranteeAmountTotal = 0;
        let marketAmountTotal = 0;

        let realGuaranteeAmountInLoanTotal = guaranteeAmountInLoanTotal !== undefined ? guaranteeAmountInLoanTotal : this.state.guaranteeAmountInLoanTotal;
        let realMarketAmountInLoanTotal = marketAmountInLoanTotal !== undefined ? marketAmountInLoanTotal : this.state.marketAmountInLoanTotal;

        response.map((item) => {
            item = this.calculateAmount(item);

            guaranteeAmountTotal += item.guaranteeAmount;
            marketAmountTotal += item.marketAmount;
            return '';
        });

        let realGuaranteeAmountTotal = guaranteeAmountTotal + realGuaranteeAmountInLoanTotal;

        this.setState({
            guaranteeAmountTotal: realGuaranteeAmountTotal,
            marketAmountTotal: marketAmountTotal + realMarketAmountInLoanTotal,
        });

        this.setTotalsColor(realGuaranteeAmountTotal);
    }

    getGuaranteeInAccount(account) {
        if (this.state.maturity !== undefined && this.state.maturity > 0) {

            return this.controlPanelService.getGuaranteeAccountForChange(
                this.state.loanId,
                this.state.maturity,
                account
            ).then(response => {
                this.setState({
                    guaranteeList: response,
                });
                this.calculateTotals(response);
                this.calculateSuggested();
                this.props.loading(false);
            });
        }
    }

    onEditorValueChange(props, value) {
        let guarantee = [...props.value];

        let valueNumber = withoutComma(value);

        guarantee[props.rowIndex][props.field] = valueNumber === 0 ? '' : valueNumber;

        this.setState({guaranteeList: guarantee});

        this.calculateTotals(guarantee);
    }

    numberEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            disabled={props.rowData.editable === "1"}
            value={props.rowData.newTitles}
            thousandSeparator={true}
            allowNegative={false}
            onChange={(e) => this.onEditorValueChange(props, e.target.value)}
            onBlur={(e) => this.calculateSuggested()}
        />;
    }

    disableStyleInstrument(rowData, value) {
        let isDisabled = rowData.editable === "1";

        if (isDisabled) {
            return <span style={{color: 'lightgray'}}>{value}</span>;
        } else {
            return <span>{value}</span>;
        }
    }

    disableStyleInstrumentTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, rowData[column.field]);
    }

    disableStyleInstrumentAmountTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, amount(rowData[column.field], "right"));
    }

    disableStyleInstrumentPriceTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, price(rowData[column.field], "right"));
    }

    disableStyleInstrumentNumberTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, numberWithCommaEmptyValue(rowData[column.field], "right"));
    }

    disableStyleInstrumentRateTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, rateMultipliedByOneHundred(rowData[column.field], "right"));
    }

    disableStyleInstrumentCapacityTemplate(rowData, column) {
        return this.disableStyleInstrument(rowData, capacityMultipliedOneHundred(rowData[column.field], "right"));
    }

    setTotalsColor(guaranteedAmountTotal) {
        this.setState((prevState) => {
            const loanAmount = prevState.loanAmount;
            let totalColorAux = loanAmount <= amountCalculate(guaranteedAmountTotal) ? 'green' : 'red';
            return { totalColor: totalColorAux,};
        });
    }

    render() {
        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={6} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.guaranteeAmountTotal, 'right')}
                            style={{color: this.state.totalColor}}/>
                    <Column footer={amount(this.state.marketAmountTotal, 'right')}
                            style={{color: this.state.totalColor}}/>
                </Row>
            </ColumnGroup>;


        return <GuaranteeInAccount
            disableStyleInstrumentTemplate={this.disableStyleInstrumentTemplate}
            disableStyleInstrumentAmountTemplate={this.disableStyleInstrumentAmountTemplate}
            disableStyleInstrumentPriceTemplate={this.disableStyleInstrumentPriceTemplate}
            disableStyleInstrumentNumberTemplate={this.disableStyleInstrumentNumberTemplate}
            disableStyleInstrumentRateTemplate={this.disableStyleInstrumentRateTemplate}
            disableStyleInstrumentCapacityTemplate={this.disableStyleInstrumentCapacityTemplate}
            guaranteeList={this.state.guaranteeList}
            footerColumnGroup={footerColumnGroup}
            numberEditor={this.numberEditor}
            cssStyle={this.state.cssStyle}
            isPrecioVal={this.state.isPrecioVal}
        />
    }
};